export default __webpack_public_path__ + "static/media/eurovision.91e6912a.svg";